export const API_URL = process.env.NODE_ENV === 'development' ?
    `http://${window.location.hostname}:3022` : 'https://cwa.avidlylabs.com';